module.exports = __webpack_public_path__ + "img/20220805141301.71709617.jpg";